import React from "react";

export default function CategoryStrip({ items }) {

  const styles = {
   container: {
  maxWidth: "1300px",
  margin: "0 auto",
  padding: "6px 20px 20px",
  display: "grid",
  gridTemplateColumns: "repeat(6,1fr)",
  gap: "16px"
},

    card: {

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  gap: "10px",

  background: "rgba(255,255,255,0.42)",

  backdropFilter: "blur(24px)",
  WebkitBackdropFilter: "blur(24px)",

  border: "1px solid rgba(255,255,255,0.55)",

  borderRadius: "999px",

  padding: "18px 22px",

  color: "#111111",

  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "1.4px",
  textTransform: "uppercase",

  boxShadow:
    `
      inset 0 1px 0 rgba(255,255,255,0.9),
      0 6px 20px rgba(0,0,0,0.04),
      0 20px 40px rgba(0,0,0,0.03)
    `,

  transition: "all .25s ease",

  transform: "translateZ(0)",

  cursor: "pointer",
},

    icon: {
      fontSize: "26px",
      marginBottom: "8px"
    },

cardHover: {
  transform: "translateY(-4px) scale(1.015)",

  boxShadow:
    `
      inset 0 1px 0 rgba(255,255,255,0.9),
      0 14px 28px rgba(0,0,0,0.06),
      0 30px 60px rgba(0,0,0,0.05)
    `,
},


    label: {
      fontWeight: 600
    }
  };

  return (
    <section style={styles.container}>
   {items.map((item) => {
  const Icon = item.icon;

  return (
    <div key={item.id} style={styles.card}>
      <Icon size={20} strokeWidth={1.8} />
      <span>{item.label}</span>
    </div>
  );
})}
    </section>
  );
}